import React from 'react';

import { Box, SimpleGrid, useTheme } from '@chakra-ui/react';

const ColoredGridLayout = ({
  rows = 3,
  columns = 3,
  spacing = '2px',
  boxHeight = '8px',
  selectedRow = -1,
  selectedColumn = -1,
  selectedColor = 'salmon',
}) => {
  const { colors } = useTheme();
  // const boxesArray = Array.from(Array(rows * columns).keys());

  const boxLayout = [];

  for (let i = 1; i <= rows; i++) {
    for (let j = 1; j <= columns; j++) {
      boxLayout.push({ row: i, column: j });
    }
  }

  return (
    <Box>
      <SimpleGrid templateRows={`repeat(${rows}, 1fr)`} templateColumns={`repeat(${columns}, 1fr)`} spacing={spacing}>
        {boxLayout.map((box, index) => {
          if (box.row === selectedRow && box.column === selectedColumn) {
            return <Box key={`${box.row}x${box.column}`} bg={selectedColor} height={boxHeight} />;
          }
          return <Box key={`${box.row}x${box.column}`} bg={colors.neutral.CFD7DF} height={boxHeight} />;
        })}
      </SimpleGrid>
    </Box>
  );
};

export default ColoredGridLayout;
